import { useState } from "react"
import { Box, Typography } from "@mui/material";
import TribeLogo from "@/assets/svg/tribe_icon_logo.svg?react"
import { useDeleteAccount} from "./hooks/useDeleteAccount"
import GradientBtn from "@/components/GradientBtn";
import s from "./styles.module.css"

const DeleteAccount = () => {
	const { deleteAccount } = useDeleteAccount()
	const [loginValue, setLoginValue] = useState('');
const [passwordValue, setPasswordValue] = useState('');

	return <Box sx={{ width: "100%", backgroundColor: "var(--Schemes-Surface)" }}>
		<div className={s.container}>
			<div className={s.logo}>
				<TribeLogo/>
				<Typography sx={{ paddingTop: "8px", fontSize: "22px", fontWeight: "600", lineHeight: "24px"}}>Tribe - Events and Activities</Typography>
			</div>

			<div>
			<h1 className={s.title}>
				Delete your account
			</h1>
			<form className={s.form} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>

				<div className={s.form_item}>
				<input className={s.form_input}
				type="search"
				placeholder="Login"
				name="username"
						spellCheck="false"
              autoComplete="off"
              autoCapitalize="off"
              maxLength={50}
							value={loginValue}
							onChange={(e) => setLoginValue(e.target.value)}
              required
							/>
				</div>
				<div className={s.form_item}>
				<input className={s.form_input}
				type="password"
				placeholder="Password"
				name="password"
				maxLength={50}
				autoComplete="off"
              required
							value={passwordValue}
							onChange={(e) => setPasswordValue(e.target.value)}/>
				</div>
				<GradientBtn
									type="submit"
									title="Delete account"
									aria-label="delete account"
									textStyle={{ fontSize: "12px", textTransform: "uppercase" }}
									disabled={!loginValue || !passwordValue}
									btnStyle={{
										width: "100%",
										height: "36px",
										padding: "10px 8px",
										fontSize: "12px",
										...((!loginValue || !passwordValue) && { opacity: 0.5, pointerEvents: "none" })
									}}
									handleAction={() => deleteAccount(loginValue, passwordValue)}
								/>
			</form>
			</div>
				<div className={s.support}>
					<Typography variant="body2" color={"var(--Schemes-On-Surface)"}>For any problems, please contact our support team: </Typography>
					<Typography variant="body2" color={"var(--Schemes-Primary)"}><a href="mailto:covenantstartup@gmail.com">covenantstartup@gmail.com</a></Typography>
				</div>
		</div>
	</Box>;
};
export default DeleteAccount;